import { connect } from 'react-redux';
import ManageGenericKpisWithModal from '../components/kpis_library/ManageGenericKpisWithModal';

import {
  manageKpisLibrarySelection,
  linkKpiToLibrary,
  updateUsedGenericKpis,
} from '../api/kpisLibraryApi';

const mapStateToProps = state => ({
  kpisLibrary: state.kpisLibrary,
  company: state.company,
});

const mapDispatchToProps = {
  manageKpisLibrarySelection,
  linkKpiToLibrary,
  updateUsedGenericKpis,
};

export default connect(mapStateToProps, mapDispatchToProps)(ManageGenericKpisWithModal);
